<template>
    <div class="MentoringReviewCard bg-white dark:bg-surface-card xl:h-[429px] xl:max-w-xl xl:rounded-2xl">
        <div class="flex h-full flex-col px-12 py-14">
            <div class="flex flex-col-reverse xl:flex-row">
                <h3 class="mb-4 text-left text-2xl font-black text-black dark:text-white">{{ review.title }}</h3>
                <!-- <CButton
                    v-if="review?.role === 'Mentor'"
                    class="mb-11 h-10 w-24"
                    :to="{ path: review?.link }"
                    :variant="'primary-150'"
                    >{{ review.role }}</CButton
                > -->
            </div>

            <CText variant="muted">
                {{ review?.body }}
            </CText>

            <nuxt-link
                v-if="review?.role === 'Mentor'"
                class="mt-auto flex flex-row pt-4"
                title="Zobraziť profil mentora"
                :to="{ path: review?.link }"
            >
                <img alt="profilovka" class="size-12 rounded-full object-cover" :src="review?.img" />
                <div class="ml-4 flex flex-col">
                    <CText class="underline hover:no-underline" :variant="'primary'">{{ review?.name }}</CText>
                    <CText v-if="review?.job" class="text-sm" variant="muted">
                        {{ review?.job }}
                    </CText>
                    <CText v-else class="text-sm" variant="muted">
                        {{ review?.role }}
                    </CText>
                </div>
            </nuxt-link>

            <div v-else class="mt-auto flex flex-row pt-4">
                <img alt="profilovka" class="size-12 rounded-full object-cover" :src="review?.img" />
                <div class="ml-4 flex flex-col">
                    <CText>{{ review?.name }}</CText>
                    <CText v-if="review?.job" class="text-sm" variant="muted">
                        {{ review?.job }}
                    </CText>
                    <CText v-else class="text-sm" variant="muted">
                        {{ review?.role }}
                    </CText>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CText from '@/components/ui/CText.vue'

defineProps({
    review: {
        type: Object,
        default: () => ({})
    }
})
</script>

<style lang="postcss" scoped>
.MentoringReviewCard {
    @media screen and (min-width: 1280px) {
        box-shadow: -8px -4px 60px 0px rgba(152, 149, 171, 0.25);
    }
}
</style>
